import Phaser from "phaser";

export class MovingObject {
  graphic: Phaser.GameObjects.Arc;
  isActive: boolean = false;
  hasScored: boolean = false;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    this.graphic = scene.add.circle(x, y, 8, 0x44aaff);
    this.graphic.setDepth(50);
  }

  get x(): number {
    return this.graphic.x;
  }

  get y(): number {
    return this.graphic.y;
  }

  setPosition(x: number, y: number): void {
    this.graphic.setPosition(x, y);
  }

  setActive(active: boolean): void {
    this.isActive = active;
    this.graphic.setFillStyle(active ? 0x88ddff : 0x44aaff);
  }

  resetScored(): void {
    this.hasScored = false;
  }

  destroy(): void {
    this.graphic.destroy();
  }
}
